import React from "react";
export default function PhysicalCycle() {
  return (
    <>
      <section className="physical-cycle-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h3 className="heading center-heading">The Document Lifecycle</h3>
              <p className="sub-heading">Dox and Box secures and streamlines your entire document journey with automation and enterprise-grade tools</p>
              <img src="/assets/images/physical-cycle.webp" alt="Physical Cycle" />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
